import { AsyncPipe, NgStyle } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  LearnizState,
  LottieComponent,
  SafeHtmlPipe,
  timeCodeToSeconde,
  TimePipe,
  WordingPipe,
} from '@jump-tools-front/shared';
import { BackgroundType, CustomImage, LearnizChapter } from '@jump-tools-front/shared-interfaces';
import { Store } from '@ngxs/store';
import { first, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'learniz-landing-intro',
  templateUrl: './landing-intro.component.html',
  styleUrls: ['./landing-intro.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, LottieComponent, AsyncPipe, WordingPipe, SafeHtmlPipe, TimePipe],
})
export class LandingIntroComponent implements OnInit, AfterViewInit {
  private _store = inject(Store);
  readonly model$ = this._store.select(LearnizState.getLearniz);
  readonly progress$ = this._store.select(LearnizState.getProgress);

  @Output() readonly goDown = new EventEmitter<void>();

  @ViewChild(LottieComponent) lottieComponent: LottieComponent;

  imagesTypes = BackgroundType;
  introImage: CustomImage;

  ngOnInit(): void {
    const styleParams = this._store.selectSnapshot(LearnizState.session).learniz.params.styleParams;
    this.introImage = styleParams.landingBackgroundImages
      ? styleParams.landingBackgroundImages.main
      : environment.defaultStyleProperties.landingBackgroundImages.main;
  }

  ngAfterViewInit(): void {
    if (this.introImage.type === BackgroundType.LOTTIE) {
      this.lottieComponent.play({ startFrame: 0, endFrame: 229, forceFlag: true });
      this.lottieComponent.completed
        .pipe(
          first(),
          tap(() => {
            this.lottieComponent.loop = true;
            this.lottieComponent.play({ startFrame: 228, endFrame: 309, forceFlag: true });
          }),
        )
        .subscribe();
    }
  }

  getTotalRecommendedDuration(chapters: LearnizChapter[]): number {
    return chapters.reduce((accu, chapter) => {
      const duration = timeCodeToSeconde(chapter.recommendedDuration) || 0;
      return accu + duration;
    }, 0);
  }
}
